import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body {
    color: var(--gray-900) !important;
    overflow-y: auto !important;
  }

  ._font-14 {
    font-size: 0.875rem;
  }

  ._font-18 {
    font-size: 1.125rem;
  }

  ._font-weight-semibold {
    font-weight: 600;
  }

  ._font-weight-extrabold {
    font-weight: 800;
  }

  ._font-weight-black {
    font-weight: 900;
  }

  [data-type="mention"], [data-action="open-profile"] {
    color: var(--blue) !important;
    text-decoration: none !important;

    &:hover {
      text-decoration: underline !important;
    }
  }

  @keyframes fadeInTooltip {
    0% {
      opacity: 0;
      transform: scale(0.8);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  .tour-app-consumer-bg-layer{
    box-shadow: var(--gray-500) 0px 0px 0px 5000px !important;
    opacity: 0.7 !important;
    border-radius: var(--spacer-3) !important;
  }

  .tour-app-consumer{
    opacity: 0;
    background-color: var(--gray-100) !important;
    border-radius: var(--spacer-3) !important;
    animation: fadeInTooltip 0.5s forwards 0.5s;

    .introjs-tooltipbuttons{
      border:none;
      padding:0.75rem;

      .introjs-donebutton{
        background: var(--blue);
        border-color: var(--blue);
        color: var(--white);
        text-shadow:none;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: var(--border-radius);

        &:focus{
          background: var(--blue-darker);
          border-color: var(--blue-darker);
        }

        &:hover{
          background: var(--blue-dark);
          border-color: var(--blue-dark);
        }
      }
    }

    .introjs-tooltip-header{
      display: none ;
    }

    .introjs-skipbutton{
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
    }

    .introjs-tooltiptext{
      padding: .75rem !important;
    }

    .introjs-arrow.top,.introjs-arrow.top-middle{
      border-bottom-color: var(--gray-100) !important;
    }

    .introjs-arrow.bottom, .introjs-arrow.bottom-middle{
      border-top-color: var(--gray-100) !important;
    }

    .introjs-arrow.left{
      border-right-color:var(--gray-100) !important;
    }

    .introjs-arrow.right{
      border-left-color:var(--gray-100) !important;
    }
  }
`

export default GlobalStyle
